import { FILES_BASE_URL } from "./filesUrl";
import { publicRuntimeConfig } from "../config/publicRuntimeConfig";

export function cmsImagePreviewUrl(value: string): string | null {
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  if (value.startsWith("/") && !value.startsWith("//"))
    return `${(publicRuntimeConfig.cmsImageBaseUrl ?? FILES_BASE_URL).replace(/\/+$/, "")}${value}`;
  if (/^[a-zA-Z0-9_-]+$/.test(value)) return `https://www.legal500.com/assets/staff/${value}.jpeg`;
  return null;
}
